import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API, { pagesApiUrl as PageQK } from './api';
import { ResponseType } from 'src/constants/data';

export const useGetPage = (slug?: string) => {
  return useQuery({
    queryKey: [PageQK, ResponseType.Single, slug],
    queryFn: () => API.getPageBySlug(slug),
    placeholderData: keepPreviousData,
    enabled: !!slug
  });
};

export const useGetMenuPage = () => {
  return useQuery({
    queryKey: [PageQK, ResponseType.List],
    queryFn: () => API.getMenuPages(),
    placeholderData: keepPreviousData
  });
};
